import { environment } from '@mg-platform/core/core-util'

export const CATEGORIES_API_URL = {
  getCategories: `${environment.apiUrl}/categories/summary`,
  getCategoriesList: `${environment.apiUrl}/categories/list`,
  exportCategories: `${environment.apiUrl}/categories/summary-export`
}
